<script>
  export let options=[];
  export let value = null;
  export let prefix = null;
  export let postfix = null;
  export let compact = false;

</script>

<div class="buttons" class:compact={compact}>
  {#if prefix}
    <div class="buttons-pre">{prefix}</div>
  {/if}
  {#each options as o}
    <div class="button" class:active={o.value===value} on:click={() => { value = o.value; }}>
      <span>{o.label}</span>
    </div>
  {/each}
  {#if postfix}
    <div class="buttons-post">{postfix}</div>
  {/if}
</div>

<style>
  .buttons {
    text-align: center;
  }

  .buttons-pre {
    display: inline-block;
    font-weight: bold;
    margin-right: 5px;
    user-select: none;
  }

  .buttons-post {
    display: inline-block;
    font-weight: bold;
    margin-left: 5px;
    user-select: none;
  }

  .button {
    padding: 2px 7px;
    margin: 5px 10px;
    display: inline-block;
    position: relative;
    white-space: nowrap;
    font-weight: bold;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    transition: transform 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
    transform-origin: center center;
    transform: scale(1);
  }

  .compact .button {
    margin: 2px;
  }

  @media (max-width: 400px) {
    .button {
      margin: 5px;
    }
  }

  .button span {
    z-index: 1;
    position: relative;
  }

  .button::before {
    content: ' ';
    position: absolute;
    bottom: 0;
    left: 7px;
    width: calc(100% - 14px);
    height: 4px;
    background-color: #F9D914;
    border-radius: 0;
    transition: height 0.3s ease, left 0.2s ease, width 0.2s ease, border-radius 0.3s ease;
  }

  .button.active {
    pointer-events: none;
  }

  .button.active::before {
    height: 100%;
    left: 0;
    width: 100%;
    border-radius: 6px;
  }

  .button:not(.active):hover {
    transform: scale(1.05);
  }

  .button:not(.active):hover::before {
    left: 0;
    width: 100%;
    height: 12px;
  }



</style>
